<template>
  <section class="position-fixed p-1 round shadow"
    style="top: 153px; right: 1px; background-color: #fff;"
  >
    <template v-if="backButton">
      <b-button variant="secondary" size="sm" block
        @click="$router.go(-1)"
      >
        <feather-icon icon="ArrowLeftIcon" />
      </b-button>
    </template>

    <template v-if="updateButton">
      <hr>
      <b-button :disabled="isDisabledUpdate" variant="success" size="sm" block class="mt-1"
        @click="$emit('update')"
      >
        <b-spinner v-if="isUpdating" small />
        <feather-icon v-else icon="CheckIcon" />
      </b-button>
    </template>

    <template v-if="deleteButton">
      <hr>
      <delete-button size="sm" @delete="$emit('delete')">
        <b-spinner v-if="isDeleting" small />
        <feather-icon v-else icon="Trash2Icon" />
      </delete-button>
    </template>

    <template>
      <hr>
      <action-record-button size="sm" @openActionTableModal="openActionTableModal" >
        <feather-icon icon="ClockHistoryIcon" />
      </action-record-button>
    </template>

    <action-table-modal ref="modalActionTable" />
  </section>
</template>
<script>
import DeleteButton from './DeleteButton.vue'
import ActionRecordButton from './ActionRecordButton.vue'
import ActionTableModal from './../../../../modules/action_record/views/_components/ActionTableModal.vue'

export default {
  name: 'ActionButtons',
  components: {
    DeleteButton,
    ActionRecordButton,
    ActionTableModal
  },
  props: {
    updateButton: { type: Boolean, default: false },
    backButton: { type: Boolean, default: false },
    deleteButton: { type: Boolean, default: false },
    isUpdating: { type: Boolean, default: false },
    isDeleting: { type: Boolean, default: false },
    isDisabledUpdate: { type: Boolean, default: false }
  },
  computed: {
    documentId() {
      const params = this.$route.params
      return Object.keys(params)[0] ? params[Object.keys(params)[0]] : ''
    }
  },
  methods: {
    openActionTableModal(){
      this.$refs.modalActionTable.openActionTableModal(this.documentId)
    }
  }
}
</script>
